import React, { useState, useRef, useEffect } from 'react';
import { TextField, InputLabel, makeStyles } from '@material-ui/core';
import LightTooltip from "../../LightTooltip";
import styles from "../styles";

const useStyles = makeStyles(styles);

const ToolTippedTextField = (props) => {
  const {
    id,
    label,
    labelIcon,
    name,
    type,
    placeholder,
    required,
    initialValue,
    error,
    disabled,
    onChange,
    minValue,
    maxValue,
    minLength,
    maxLength,
    step,
  } = props;

  useEffect(() => {
    setValue(initialValue || "")
  }, [initialValue]);

  const inputProps = {};
  if (minValue !== undefined || minValue !== null) {
    inputProps.min = minValue;
  }
  if (maxValue !== undefined || maxValue !== null) {
    inputProps.max = maxValue;
  }
  if (minLength !== undefined || minLength !== null) {
    inputProps.minLength = minLength;
  }
  if (maxLength !== undefined || maxLength !== null) {
    inputProps.maxLength = maxLength;
  }
  if (step !== undefined || step !== null) {
    inputProps.step = step;
  }

  const [value, setValue] = useState(initialValue || "");
  const [isOverflowed, setIsOverflow] = useState(initialValue && initialValue.length > 0);

  const textElementRef = useRef({});
  const classes = useStyles();

  const checkOverFlow = (e) => {
    if (!value) {
      setIsOverflow(false);
    } else if (textElementRef.current && value) {
      setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChange !== undefined && typeof onChange === "function") {
      onChange(e.target.value);
    }
  };

  return (
    <>
    <InputLabel className={classes.inputLabel}>
      {label}
      {required && (
        <span
          aria-hidden="true"
          className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
          style={{ color: "#E30613" }}
        >
          &thinsp;*
        </span>
      )}
      {labelIcon}
    </InputLabel>
    <LightTooltip
      title={<span>{value}</span>}
      placement="top-start"
      disableFocusListener
      disableHoverListener={!isOverflowed}
      style={{ paddingBottom: 0, paddingTop: 0 }}
    >
      <TextField
        inputRef={textElementRef}
        name={name}
        id={id}
        size="small"
        margin="dense"
        variant="outlined"
        error={error}
        value={value}
        type={type || "text"}
        disabled={disabled}
        required={required}
        fullWidth
        multiline={false}
        placeholder={placeholder}
        className={classes.inputField}
        onChange={handleChange}
        onBlur={checkOverFlow}
        inputProps={
          {
            ...inputProps,
            style: {
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }
          }
        }
      />
    </LightTooltip>
    </>
  );
}

export default ToolTippedTextField;